"use client";

import React, { useMemo } from "react";
import "./ArchiveProductTemplate.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import ShopHero from "@/pages/Shop/sections/ShopHero";
import ProductListings from "@/pages/Shop/sections/ProductListings";
import { decodeEntities } from "@/lib/decodeEntities";

declare const wvcClient: any;
const getWvcClient = () =>
  typeof wvcClient !== "undefined" ? wvcClient : (window as any).wvcClient;

export default function ArchiveProductTemplate() {
  const currentParams = useMemo(() => {
    try {
      const client = getWvcClient();
      return client && typeof client.getCurrentWPQueryParams === "function"
        ? client.getCurrentWPQueryParams()
        : {};
    } catch {
      return {};
    }
  }, []);

  const currentTermParams = useMemo(() => {
    try {
      const client = getWvcClient();
      return client && typeof client.getCurrentWPTermQueryParams === "function"
        ? client.getCurrentWPTermQueryParams()
        : {};
    } catch {
      return {};
    }
  }, []);

  // Determine current archive category or tag term
  const termSlug = String(
    currentParams?.product_cat ||
      currentTermParams?.slug ||
      currentParams?.category_name ||
      currentParams?.product_tag ||
      ""
  );

  const termName = String(
    currentTermParams?.name ||
      currentParams?.term_name ||
      termSlug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );

  const isTag = Boolean(currentParams?.product_tag || currentTermParams?.taxonomy === "product_tag");
  const taxonomy = isTag ? "product_tag" : "product_cat";

  const initialTerm = termSlug
    ? {
        slug: termSlug,
        name: termName,
        taxonomy,
      }
    : undefined;

  const archiveTitle = termSlug
    ? `${decodeEntities(termName)} Water Heaters`
    : "Water Heating Equipment Catalog";

  const archiveDescription = termSlug
    ? `Explore our curated selection of high-efficiency ${decodeEntities(termName).toLowerCase()} natural gas water heaters, engineered for reliable recovery and domestic service.`
    : "Explore high-recovery storage tanks, tankless models, and specialty water heaters engineered for domestic heating efficiency and dependable performance.";

  return (
    <div>
      <Header />
      <ShopHero customHeading={archiveTitle} customDescription={archiveDescription} />
      <ProductListings initialTerm={initialTerm} />
      <Footer />
    </div>
  );
}
